module.exports = __webpack_public_path__ + "img/template04.bbe911bd.jpg";